import { History } from "history";
import React, { useState } from "react";
import {
  BrowserRouterProps as NativeBrowserRouterProps,
  Router,
} from "react-router-dom";

export interface BrowserRouterProps
  extends Omit<NativeBrowserRouterProps, "window"> {
  history: History;
}

const getDocumentTitle = (pathname: string): string => {
  if (new RegExp('^/login').test(pathname)) {
    return 'Login';
  }
  if (new RegExp('^/register/.+').test(pathname)) {
    return 'Register';
  }
  if (new RegExp('^/active-orders/.+/support').test(pathname)) {
    return 'Order Support';
  }
  if (new RegExp('^/active-orders/.+/edit').test(pathname)) {
    return 'Order Edit';
  }
  if (new RegExp('^/active-orders/.+').test(pathname)) {
    return 'Order Details';
  }
  if (new RegExp('^/active-orders').test(pathname)) {
    return 'Active Orders';
  }
  if (new RegExp('^/chatrooms').test(pathname)) {
    return 'Chat';
  }
  return '';
};

function BrowserRouter(props: BrowserRouterProps) {
  const { history, ...restProps } = props;

  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  React.useLayoutEffect(() => history.listen(state => {
    document.title = getDocumentTitle(state.location.pathname);
    setState(state);
  }), [history]);

  return (
    <Router
      {...restProps}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
}
export default React.memo(BrowserRouter);
